<template>
    <div class="rota">
      <table class="table table-striped table-hover">
        <tr>
          <th></th>
          <th>Available</th>
          <th>Quantity</th>
          <th v-if="charity || newCharity">Open For Arrival</th>
          <th v-if="charity || newCharity">Latest Arrival</th>
          <th v-if="retailer || newRetailer">Pickup Time</th>
          <th v-if="charity || newCharity">Contact Name</th>
          <th v-if="charity || newCharity">Contact Email</th>
          <th v-if="charity || newCharity">Contact Number</th>
        </tr>
        <tbody>
        <tr v-for="(day) in rota" :key="day.dayOfTheWeek">
          <td class="day-column">{{ day.dayOfTheWeek }}</td>
          <td class="available-column">
            <base-input>
              <select class="form-control select--yes-no" :class="{ 'select--yes': day.available=='true'}" v-model="day.available" @change="checkAvailible('availability',day.dayOfTheWeek); emitChanges()">
                <option value="true">Yes</option>
                <option value="false">No</option>
              </select>
            </base-input>
          </td>
          <td class="quantity-column">
            <base-input>
              <select class="form-control" v-model="day.quantity" @change="checkAvailible('quantity',day.dayOfTheWeek); emitChanges()">
                <option value="0">{{supplyAndDemandText(0)}}</option>
                <option value="1">{{supplyAndDemandText(1)}}</option>
                <option value="2">{{supplyAndDemandText(2)}}</option>
                <option value="3">{{supplyAndDemandText(3)}}</option>
              </select>
            </base-input>
          </td>
          <td v-if="charity || newCharity">
            <base-input addon-left-icon="ni ni-calendar-grid-58">
              <el-time-picker :picker-options="{
                format: 'HH:mm A'
              }" @change="emitChanges()" v-model="day.startTime"></el-time-picker>
            </base-input>
          </td>
          <td>
            <base-input addon-left-icon="ni ni-calendar-grid-58">
              <el-time-picker :picker-options="{
                format: 'HH:mm A'
              }" @change="emitChanges()" v-model="day.endTime"></el-time-picker>
            </base-input>
          </td>
          <td v-if="charity || newCharity">
            <base-input @blur="emitChanges()" type="text" v-model="day.contactName"></base-input>
          </td>
          <td v-if="charity || newCharity">
            <base-input @blur="emitChanges()" type="text" v-model="day.contactEmail"></base-input>
          </td>
          <td v-if="charity || newCharity">
            <base-input @blur="emitChanges()" type="text" v-model="day.contactPhone"></base-input>
          </td>
        </tr>
        </tbody>
      </table>
    </div>
</template>

<script>
  // Import
  import { TimePicker } from 'element-ui';
  import days from '../../util/days-of-the-week';
  import supplyAndDemandLocalisation from '../../localisation/en/supply-and-demand';
  //
  export default {
    name: 'rota-form',

    components: {
      [TimePicker.name]: TimePicker
    },

    props:[
      'newRetailer',
      'newCharity',
      'retailer',
      'charity',
      'availabilityPeriods',
      'skipMountedEmit'
    ],

    data() {

      let startTime = new Date().setHours(9,0,0);
      let endTime = new Date().setHours(18,0,0);

      if(this.retailer || this.newRetailer){
        // startTime = new Date().setHours(0,0,0);
        endTime = new Date().setHours(17,0,0);
      }

      return {
        location: null, // Charity or retailer
        supplyOrDemand: 'demand',
        rota: [
          { dayOfTheWeek: 'Monday',
            available: 'true',
            quantity: '1',
            startTime: new Date(startTime),
            endTime: new Date(endTime),
            contactName:null,
            contactEmail:null,
            contactPhone:null
          },
          { dayOfTheWeek: 'Tuesday',
            available: 'true',
            quantity: '1',
            startTime: new Date(startTime),
            endTime: new Date(endTime),
            contactName:null,
            contactEmail:null,
            contactPhone:null
          },
          { dayOfTheWeek: 'Wednesday',
            available: 'true',
            quantity: '1',
             startTime: new Date(startTime),
            endTime: new Date(endTime),
            contactName:null,
            contactEmail:null,
            contactPhone:null
          },
          { dayOfTheWeek: 'Thursday',
            available: 'true',
            quantity: '1',
            startTime: new Date(startTime),
            endTime: new Date(endTime),
            contactName:null,
            contactEmail:null,
            contactPhone:null
          },
          { dayOfTheWeek: 'Friday',
            available: 'true',
            quantity: '1',
            startTime: new Date(startTime),
            endTime: new Date(endTime),
            contactName:null,
            contactEmail:null,
            contactPhone:null
          },
          { dayOfTheWeek: 'Saturday',
            available: 'false',
            quantity: '0',
            startTime: new Date(startTime),
            endTime: new Date(endTime),
            contactName:null,
            contactEmail:null,
            contactPhone:null
          },
          { dayOfTheWeek: 'Sunday',
            available: 'false',
            quantity: '0',
            startTime: new Date(startTime),
            endTime: new Date(endTime),
            contactName:null,
            contactEmail:null,
            contactPhone:null
          }
        ]
      };
    },
  
    mounted(){
      
      if(this.retailer){
        this.supplyOrDemand = 'supply';
        this.location = this.retailer;
      } else {
        this.location = this.charity;
      }

      // Send an initial set of data to the parent form for new charities and retailers
      if(!this.newRetailer && !this.newCharity) {
        this.importData();
      }

      if(!this.skipMountedEmit){
        this.emitChanges();
      }
    },

    watch:{
      availabilityPeriods: function(newValue, oldValue){
        this.importData();
      },
      retailer: function(){
        if(this.retailer) this.location = this.retailer;
        this.importData();
      },
      charity: function(){
        if(this.charity) this.location = this.charity;
        this.importData();
      }
    },

    computed:{
        
    },

    methods: {

      supplyAndDemandText(index){
        return supplyAndDemandLocalisation.supplyAndDemandShort[index];
      },

      /**
       * The form data has changed
       */
      emitChanges() {
        this.$emit('updated', this.exportData() );
      },

      /**
       * Either a days quantity or available dropdown has changed
       */
      checkAvailible(changedInputType,dayName){
        let rotaDay = this.rota.find((p)=>{return p.dayOfTheWeek == dayName});
        // Quantity changed
        if(changedInputType == 'quantity'){
          if(rotaDay.quantity == '0'){
            rotaDay.available = 'false';
          }else{
            rotaDay.available = 'true';
          }
        // Available changed
        }else{
          if(rotaDay.available == 'false'){
            rotaDay.quantity = '0';
          }
        }
      },

      /**
       * Import all API formatted data
       */
      importData(){
        for (let index = 0; index < days.length; index++) {
          const day = days[index];
          this.importDataForDay(day);
        }
      },

      /**
       * Import data into a format usable by the form
       * @param {string} dayName The day we are importing
       */
      importDataForDay(dayName){
        this.justImported = true;
        // Get the correct rota day
        let rotaDay = this.rota.find((p)=>{return p.dayOfTheWeek == dayName});
        // Get the activity period for this day
        let period = this.availabilityPeriods.find((p)=>{return p.dayOfTheWeek == dayName});
        // Do we have any avaiability 
        if(period) {
          rotaDay.startTime = new Date().setHours(period.startTimeHours,period.startTimeMinutes,0);
          rotaDay.endTime = new Date().setHours(period.endTimeHours,period.endTimeMinutes,0);
          rotaDay.contactName = period.contactName;
          rotaDay.contactEmail = period.contactEmail;
          rotaDay.contactPhone = period.contactPhone;
        }

        //
        if(this.location){
          rotaDay.quantity = '' + this.location[this.supplyOrDemand + dayName];

          if(this.location[this.supplyOrDemand + dayName] == 0) rotaDay.available = 'false';
          else rotaDay.available = 'true';
        }
      },

      /**
       * Export the form data in formats that the API can read
       */
      exportData(){
        let exportData = {periods:[], quantities:[]};
        // Loop through day data
        for (let index = 0; index < days.length; index++) {
          const day = days[index];
          this.exportDataForDay(day, exportData);
        }

        return exportData;
      },

       /**
       * Export data into a format usable by the API
       * @param {string} dayName The day we are importing
       * @param {object} exportData The data for export we will add this day to
       */
      exportDataForDay(dayName, exportData){
        let rotaDay = this.rota.find((p)=>{return p.dayOfTheWeek == dayName});
        // Available that day?
        if(rotaDay.available == 'true'){
          exportData.quantities.push(rotaDay.quantity);
        }else{
          exportData.quantities.push(0);
        }
        // Activity period
        let startTime = new Date(rotaDay.startTime);
        let endTime = new Date(rotaDay.endTime);
        // Create the activity perdio for that day
        exportData.periods.push({
          dayOfTheWeek: rotaDay.dayOfTheWeek,
          retailerId: this.retailer ? this.retailer.id : undefined,
          charityId: this.charity ? this.charity.id : undefined,
          startTimeHours: startTime.getHours(),
          startTimeMinutes: startTime.getUTCMinutes(),
          endTimeHours: endTime.getHours(),
          endTimeMinutes: endTime.getUTCMinutes(),
          contactName:rotaDay.contactName,
          contactEmail:rotaDay.contactEmail,
          contactPhone:rotaDay.contactPhone
        });
      }
    },
  }
</script>

<style lang="scss" scoped>
  //  @import '../../../assets/sass/argon.scss';

  .rota {
    max-width: 100%;
    overflow:auto
  }
  

  .day-column{
    min-width: 120px;
  }

  .available-column{
    min-width: 140px;
  }

  .quantity-column{
    min-width: 140px;
  }

  .select--yes-no{
    background: red;
    color:white;
    width: 80px;
  }

  .select--yes{
    background: green;
  }

  .form-group{
    margin-bottom:0;
  }

  .el-date-editor.el-input{
    width: 125px;
  }

</style>